import { render, staticRenderFns } from "./GFileImage.vue?vue&type=template&id=bfc54210&"
import script from "./GFileImage.vue?vue&type=script&lang=js&"
export * from "./GFileImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports